import actions from './_actions';
import getters from './_getters';
import mutations from './_mutators';

// CLEAN - There seems to be some debug code left in this file
const state = {
    activeConversationId: null,
    conversations: [
        // {
        //     id: null,
        //     sender: null,
        //     addressee: null,
        //     messages: null,
        //     events: null,
        // }
    ],
    isLoadingConversation: false,
    isLoadingMessages: false,
    isSendingMessage: false,
    shouldDisplayTypingEvent: false,
    isLoadingProjectEvents: false,

    fileDummy: '123abc',
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};



// WEBPACK FOOTER //
// ./src/taskflex/conversations/store/index.js